import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {HALTED_VIEW_ICON} from 'analysis-tool/data-view/AnalysisViewUtils';
import {assertAndContinue} from 'Asserts';
import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {FONT_PROXIMA_16} from 'styles/FontConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import {GRAY_DARK, GRAY_LIGHT} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {AnalysisMainViewItemType, MainViewComponentProps} from './MainViewTypes';

export default function HaltedStepView({
  step,
}: MainViewComponentProps<AnalysisMainViewItemType.HALTED>): JSX.Element {
  assertAndContinue(
    step.statusCode === PipelineStepStatusCode.HALTED,
    `Expected to only use this component with ${PipelineStepStatusCode.HALTED} steps`,
    {statusCode: step.statusCode, stepId: step.id, stepType: step.definition.stepType}
  );

  return (
    <div className={css(styles.wrapper)} {...getTestProps({component: 'HaltedStepView', element: 'root'})}>
      <BenchlingIcon icon={HALTED_VIEW_ICON} className={css(styles.icon)} />
      <p className={css(styles.titleText)}>Halted</p>
    </div>
  );
}

const styles = StyleSheet.create({
  icon: {
    color: GRAY_LIGHT,
    height: '60px',
    width: '60px',
    marginBottom: 20,
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  titleText: {
    ...FONT_PROXIMA_16,
    color: GRAY_DARK,
  },
});
